var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBiPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 1.75C14.0815 1.75 14.3995 1.8817 14.6339 2.11612C14.8683 2.35054 15 2.66848 15 3V18C15 18.3315 14.8683 18.6495 14.6339 18.8839C14.3995 19.1183 14.0815 19.25 13.75 19.25H6.25C5.91848 19.25 5.60054 19.1183 5.36612 18.8839C5.1317 18.6495 5 18.3315 5 18V3C5 2.66848 5.1317 2.35054 5.36612 2.11612C5.60054 1.8817 5.91848 1.75 6.25 1.75H13.75ZM6.25 0.5C5.58696 0.5 4.95107 0.763392 4.48223 1.23223C4.01339 1.70107 3.75 2.33696 3.75 3V18C3.75 18.663 4.01339 19.2989 4.48223 19.7678C4.95107 20.2366 5.58696 20.5 6.25 20.5H13.75C14.413 20.5 15.0489 20.2366 15.5178 19.7678C15.9866 19.2989 16.25 18.663 16.25 18V3C16.25 2.33696 15.9866 1.70107 15.5178 1.23223C15.0489 0.763392 14.413 0.5 13.75 0.5L6.25 0.5Z",
    fill: "#3E423F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18C10.3315 18 10.6495 17.8683 10.8839 17.6339C11.1183 17.3995 11.25 17.0815 11.25 16.75C11.25 16.4185 11.1183 16.1005 10.8839 15.8661C10.6495 15.6317 10.3315 15.5 10 15.5C9.66848 15.5 9.35054 15.6317 9.11612 15.8661C8.8817 16.1005 8.75 16.4185 8.75 16.75C8.75 17.0815 8.8817 17.3995 9.11612 17.6339C9.35054 17.8683 9.66848 18 10 18Z",
    fill: "#3E423F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiPhone);
export default __webpack_public_path__ + "static/media/bi_phone.5c074098a720aa185fcbbde8ff6bde9d.svg";
export { ForwardRef as ReactComponent };